import useTranslations from '@/i18n/useTranslations';
import { FormDropdown } from '@/shared-components/dropdown';
import FormError from '@/shared-components/error/components/FormError';
import { getArtworkTaxonomyOptions } from '@/utils/artworkTaxonomy';

import './styles/ArtworkMultipleInput.css';

export default function ArtworkMultipleInput({
  placeholder,
  type,
  options,
  category,
  value,
  element,
  error,
  previewMode,
  onChange,
  margin,
  infoIcon = null,
  disabled = false,       // ⇐ añadimos
  className = "",         // ⇐ añadimos tu can-edit si quieres
}) {
  const t = useTranslations('common.forms.add_artwork');
  const selectedValues = Array.isArray(value) ? value : [];
  const displayOptions = getArtworkTaxonomyOptions(options, category, t);
  const getLabel = (value) => displayOptions.find((option) => option.value === value)?.label || value;

  return (
    <>
      <div
        className={[
          "artwork-multiple-input__outter-container",
          margin && "margin",
          className,               // tu "can-edit"
        ]
          .filter(Boolean)
          .join(" ")}>
        <FormDropdown
          className={`artwork-multiple-input__container element-non-selectable${disabled ? ' is-disabled' : ''}`}
          element={element}
          label={placeholder}
          value={selectedValues}
          options={displayOptions}
          onChange={onChange}
          multiple
          maxSelections={3}
          readOnly={disabled}
          previewMode={previewMode}
          infoIcon={infoIcon}
          optionsHeader={t('dropdown.multiple_header', { type: t(`dropdown.types.${type}`) })}
          formatValue={(selectedOptions) => selectedOptions.map((item, index) => (
            <span key={item}>
              <span className="artwork-multiple-input__index__selected">{index + 1} </span>
              {getLabel(item)}{index !== selectedOptions.length - 1 && ', '}
            </span>
          ))}
        />
                
        <FormError 
          error={error} 
          alternativeElement={`${element}_error`} 
          errorClassName="input-error" 
          element={element}
        />
      </div>
    </>
  );
}
